function PageName() {
  return (
    <div>
      <h1>This is your new page</h1>
    </div>
  )
}

export default PageName
